var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{ref:"element",tag:"component",attrs:{"contenteditable":_vm.contenteditable},on:{"input":_vm.update,"blur":_vm.update,"paste":_vm.onPaste,"keypress":_vm.onKeypress}})
}
var staticRenderFns = []

export { render, staticRenderFns }